export enum CustomErrorCodes {
  USER_NOT_FOUND = 4040,
  WORKING_OUTSIDE_PRACTICE_HOURS = 4011,
  ROCKET_CHAT_UNAUTHORIZED = 4016,
}
